<template>
  <span :class="$style.wave">
    <span :class="$style.wave__item" v-for="index in 4" :key="index" />
  </span>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'LoadingIndicator',
})
</script>

<style lang="scss" module>
@keyframes wave-surge {
  0% {
    background-color: color.change($color-surface-accent-primary, $alpha: 0.21);
    transform: translateY(0%);
  }

  16% {
    background-color: color.change($color-surface-accent-primary, $alpha: 0.33);
    transform: translateY(50%);
  }

  43% {
    background-color: color.change($color-surface-accent-primary, $alpha: 1);
    transform: translateY(-50%);
  }

  66% {
    background-color: color.change($color-surface-accent-primary, $alpha: 0.7);
    transform: translateY(0%);
  }
}

.wave {
  $size: 8px;
  $gap: math.div($size * 3, 4);
  $number: 4;

  display: inline-flex;
  width: ($size * $number) + ($gap * ($number - 1));
  align-items: center;

  &__item {
    width: $size;
    height: $size;
    background-color: $color-text-and-object-accent-primary;
    border-radius: 50%;

    &:nth-child(n + 2) {
      margin-left: $gap;
    }

    @for $i from 1 through $number {
      $duration: 2.4s;
      $delay: $i * 300ms;

      &:nth-child(#{$i}) {
        animation: wave-surge $duration ease-out $delay infinite normal;
      }
    }
  }
}
</style>
